<template>
  <b-modal
    :title="report && report.title || $t('Loading...')"
    v-model="showModal"
    size="xl"
    static
    :ok-only="true"
    lazy
  >
    <ConditionReport
      :report="report"
      :showTitle="false"
    />
  </b-modal>
</template>

<script>
import ConditionReport from "@/components/condition-report/ConditionReport.vue";

export default {
  name: "ConditionReportModal",
  components: {
    ConditionReport,
  },
  props: {
    report: Object,
    value: Boolean,
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
};
</script>
